/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".opciones[_ngcontent-%COMP%] {\r\n    text-align: center;\r\n}"];
export { styles as styles };
